import { get, post } from "../GenericServices";

const AccountingBookSettings = {
  getSetting: () => {
    return get("accounting-book-settings");
  },
  saveSetting: (data) => {
    return post("accounting-book-settings", data);
  },
};

export default AccountingBookSettings;
